module.exports = __webpack_public_path__ + "img/case1.cd62c9b2.png";